import { NgModule } from '@angular/core';
import { provideRouter } from '@angular/router';
import { LayoutEmptyComponent } from '../common/components/layout-empty/layout-empty.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard';
import { PermissionGuard } from '../../core/guards/permission.guard';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideRouter([
      {
        // Public support section (no UserAuthGuard) — reference/help pages.
        path: 'support',
        component: LayoutEmptyComponent,
        children: [
          {
            path: 'mock-data',
            loadComponent: () =>
              import('./pages/mock-data/mock-data.component').then((x) => x.MockDataComponent),
          },
          {
            // Authenticated + permission-gated — installer downloads.
            path: 'download',
            canActivate: [UserAuthGuard, PermissionGuard],
            data: { permissions: 'DOWNLOAD_ARTIFACTS' },
            loadComponent: () =>
              import('./pages/download/download.component').then((x) => x.DownloadComponent),
          },
        ],
      },
    ]),
  ],
})
export class SupportRoutingModule {}
